import React from 'react';
import '../css/WarrantieTable.css'

function WarrantiesMineur() {
  return (
    <div className="container mx-auto p-4">
            <h3 className='tableaux'><u>LE TABLEAU DES GARANTIES ET PLAFONDS</u></h3>
            <p className='description'>Le taux de remboursement et/ou prise en charge est de <strong>100 %</strong> </p>
            <h3 className="carto">Djiguiya Mineur</h3>
            <table role="none">
                <thead>
                    <th>GARANTIES</th>
                    <th>Taux DE COUVERTURE</th>
                    <th>PLAFONDS</th>
                </thead>
                <tbody>
                    <tr>
                        <td><strong>Honoraires médicaux</strong> </td>
                    </tr>
                    <tr>
                        <td>Consultation généraliste</td>
                        <td>100% des frais réels</td>
                        <td>8 000 / Acte</td>
                    </tr>
                    <tr>
                        <td>Consultation Spécialiste</td>
                        <td>100% des frais réels</td>
                        <td>10 000 / Acte</td>
                    </tr>
                    <tr>
                        <td>Visite Généraliste</td>
                        <td>100% des frais réels</td>
                        <td>8 000 / Acte</td>
                    </tr>
                    <tr>
                        <td>Visite Spécialiste</td>
                        <td>100% des frais réels</td>
                        <td>10 000 / Acte</td>
                    </tr>
                    <tr>
                        <td>Soins infirmiers (AMI-SF)</td>
                        <td>100% des frais réels</td>
                        <td>1 000 / Acte</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td>200 000 Assuré / An</td>
                    </tr>
                    <tr>
                        <td><strong>Pharmacie</strong></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>Médicaments curatifs avec une prescription médicale</td>
                        <td>100% des frais réels</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>Médicaments de confort ou d'agrément</td>
                        <td><strong>Exclus</strong></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td><strong>Analyses</strong></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>Analyse</td>
                        <td>100% des frais réels</td>
                        <td><strong>80 000 / Assuré / An</strong></td>
                    </tr>
                    <tr>
                        <td>Prélèvement</td>
                        <td>80 000 / Assuré / An</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td><strong>Radios</strong></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>Radio</td>
                        <td>100% des frais réels</td>
                        <td><strong>80 000 / Assuré / An</strong></td>
                    </tr>
                    <tr>
                        <td>Scanner / IRM</td>
                        <td>80 000 / Assuré / An</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td><strong>Soins dentaires</strong></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>Consultation et Soins</td>
                        <td>100% des frais réels</td>
                        <td><strong>50 000 / Assuré / An</strong></td>
                    </tr>
                    <tr>
                        <td>Radios</td>
                        <td>100% des frais réels</td>
                        <td><strong>50 000 / Assuré / An</strong></td>
                    </tr>
                    <tr>
                        <td>Chirurgie dentaire</td>
                        <td>100% des frais réels</td>
                        <td><strong>50 000 / Assuré / An</strong></td>
                    </tr>
                    <tr>
                        <td>Orthodontie</td>
                        <td>100% des frais réels</td>
                        <td><strong>50 000 / Assuré / An</strong></td>
                    </tr>
                    <tr>
                        <td><strong>Optique</strong></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>Soins</td>
                        <td>100% des frais réels</td>
                        <td>60 000 / Assuré / An</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td><strong>Hopitalisation</strong></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>Chambre</td>
                        <td>100% des frais réels</td>
                        <td><strong>15 000 FCFA / jour</strong></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>100% des frais réels</td>
                        <td><strong>200 000 / Assuré / an</strong></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td><strong>Plafond Mali</strong></td>
                        <td></td>
                        <td><strong>500 000 / Assuré / an</strong></td>
                    </tr>
                </tfoot>
            </table>
        </div>
  )
}

export default WarrantiesMineur